











import { defineComponent, onMounted } from "@vue/composition-api"
import { useAppBar } from "@/app/reactive/app-bar.state"
import { useBrowser } from "@/app/reactive/browser.state"
import ErrorSection from "@/app/components/common/ErrorSection.vue"

export default defineComponent({
  name: "NotFoundPage",
  components: {
    ErrorSection,
  },
  setup(props, { root }) {
    const AppBar = useAppBar()
    const Browser = useBrowser()

    const navigateToHome = () => root.$router.replace({ name: "home" })

    onMounted(() => {
      AppBar.setTitle(null)
      AppBar.setHasBackButton(false)
      Browser.setHasUnsavedData(false)
    })

    return { navigateToHome }
  },
})
